// 
/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { InputNumber } from 'antd'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'

const InputNumberC = (props) => {
  const {
    propsClassName, propsClassSpan, style,// 样式 className
    modalProps, label, ending, // 组件 功能参数
    options, query, value, searchKey, // 组件 数据源
    clearKey, killPending, reduxObj,// 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const handleValue = Object.keys(query).includes(searchKey)
    ? query[searchKey]
    : ''
  // 初始化Tag选择状态
  const [ useValue, setUseValue ] = useState(handleValue)
    useEffect(() => {
      setUseValue(handleValue)
  }, [query.refQ, query[searchKey]])

  const changeSearch = (e) => {
    setUseValue(e)
     // ----- 提交组件 -----------
     handleControl(
      props,
      { [searchKey]: e }
    )
  }
  
  return (
    <div className={propsClassName}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <InputNumber
        // -- modalProps
        placeholder={`请填写${label}`}
        style={style}
        {...modalProps}
        // ---
        value={useValue}
        onChange={changeSearch}
      />
    </div>
  )
    
}
export default InputNumberC
InputNumberC.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  query: {},
  killPending: false
}
